export default {
  name: 'experimentServerSide',

  // Google optimize experiment id
  experimentID: 'ZU6MHn_mT9-dK7EiortaxA',
  maxAge: 60 * 60 * 24 * 90, // 3 months

  variants: [
    {weight: 50},
    {weight: 50}
  ]
}